import React from 'react'
import PropTypes from 'prop-types'

import { decode, encodeAll } from '@aytm/app/insights/dashboard/lib/sanitize'

const CLASS = 'insights-portal-editor-input'

const TextEditor = props => {
  const className = `${CLASS}${props.className ? ` ${props.className}` : ''}`
  const raw = null === props.value || undefined === props.value || '' === props.value ? '' : props.value
  const value = decode(raw)
  const onValueChange = event => {
    if (props.onChange) {
      const newValue = event.target.value && '' !== event.target.value.trim() ? encodeAll(event.target.value) : null
      props.onChange({ value: newValue })
    }
  }
  return (
    <input
      className={className}
      id={props.id}
      type={'text'}
      placeholder={props.placeholder}
      value={value}
      onInput={onValueChange}
      onKeyDown={props.onKeyDown}
    />
  )
}

TextEditor.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func
}

export default TextEditor
